import { Stepper } from "./Stepper.tsx";
import { format, type RepsDraft } from "../lib/session.ts";

/**
 * The reps of one set: one figure, or two for a drop set, before and after
 * the drop — two half-width steppers on a row, so both fit above the thumb.
 *
 * A one-sided movement types a side at a time (`SidePicker`), so a side is
 * never more than this either.
 */
export function RepsInput({
  value,
  onChange,
  dropSet,
  weightKg,
  dropWeightKg,
}: {
  value: RepsDraft;
  onChange: (value: RepsDraft) => void;
  dropSet: boolean;
  weightKg: number;
  dropWeightKg: number;
}) {
  if (!dropSet) {
    return (
      <Stepper
        label="répétitions"
        value={value.reps}
        step={1}
        decimals={0}
        max={100}
        onChange={(reps) => onChange({ ...value, reps })}
      />
    );
  }

  return (
    <div>
      <p className="label px-0.5 pb-1">Répétitions · avant et après le drop</p>
      <div className="grid grid-cols-2 gap-2">
        <Reps
          caption={`avant · ${format(weightKg)} kg`}
          value={value.reps}
          onChange={(reps) => onChange({ ...value, reps })}
        />
        <Reps
          caption={`après · ${format(dropWeightKg)} kg`}
          value={value.dropReps}
          onChange={(dropReps) => onChange({ ...value, dropReps })}
        />
      </div>
    </div>
  );
}

function Reps({ caption, value, onChange }: { caption: string; value: number; onChange: (value: number) => void }) {
  return (
    <Stepper
      compact
      label={caption}
      caption={<span className="mt-0.5 block max-w-full truncate px-1 text-[0.7rem] text-ink-mute">{caption}</span>}
      value={value}
      step={1}
      decimals={0}
      max={100}
      onChange={onChange}
    />
  );
}
